import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { toast } from 'sonner';
import { MUTATION_KEYS } from 'constants/common';
import { ROUTES } from 'constants/routes';
import { ReportService } from 'services/reports';
import { type ChatReportPayload } from 'types/chat-report';

export const useSendReport = (): UseMutationResult<void, Error, ChatReportPayload> => {
  const navigate = useNavigate();
  const { t } = useTranslation(LOCIZE_NS.CHAT);
  return useMutation<void, Error, ChatReportPayload>({
    mutationKey: [MUTATION_KEYS.SEND_REPORT],
    mutationFn: async (body: ChatReportPayload) => {
      await ReportService.sendChatReport(body);
    },
    onSuccess: () => {
      toast.success(t('ChatReport.success'));
      navigate(ROUTES.CHAT);
    },
    onError: () => {
      toast.error(t('ChatReport.error'));
    },
  });
};
